export default {"src":"/_next/static/media/suitcase_40.f3bdd7ed.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};